import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { OrderRoutingModule } from './order-routing.module';
import { OrderSearchComponent } from './order-search/order-search.component';
import { SubOrderSearchComponent } from './sub-order-search/sub-order-search.component';
import { SubOrderSearchModule } from './sub-order-search/sub-order-search.module';
import { OrderSearchModule } from './order-search/order-search.module';
import { OrderProductSearchModule } from './order-product-search/order-product-search.module';
import { OrderProductSearchComponent } from './order-product-search/order-product-search.component';
import { GoogleChartsModule } from 'angular-google-charts';
import { orderSearchFeatureKey } from '@app/reducers/myoffice/order/order-search.reducer';
import { orderSearchReducer } from '@app/reducers/myoffice/order/order-search.reducer';
import { OrderSearchEffect } from '@app/effects/myoffice/order/order-search.effect';
import { orderProductSearchFeatureKey } from '@app/reducers/myoffice/order/order-product-search.reducer';
import { orderProductSearchReducer } from '@app/reducers/myoffice/order/order-product-search.reducer';
import { OrderProductSearchEffect } from '@app/effects/myoffice/order/order-product-search.effect';
import { OrderCalendarModule } from './order-calendar/order-calendar.module';
import { OrderCalendarComponent } from './order-calendar/order-calendar.component';
import { orderCalendarFeatureKey, orderCalendarReducer } from '@app/reducers/myoffice/order/order-calendar.reducer';
import { OrderCalendarEffect } from '@app/effects/myoffice/order/order-calendar.effect';
import { MonthlyOrderCountComponent } from './monthly-order-count/monthly-order-count.component';
import { MonthlyOrderCountModule } from './monthly-order-count/monthly-order-count.module';
import { OrderMileageInquiryComponent } from './order-mileage-inquiry/order-mileage-inquiry.component';
import { OrderMileageInquiryModule } from './order-mileage-inquiry/order-mileage-inquiry.module';
import { monthlyOrderCountFeatureKey, monthlyOrderCountReducer } from '@app/reducers/myoffice/order/monthly-order-count.reducer';
import { MonthlyOrderCountEffect } from '@app/effects/myoffice/order/monthly-order-count.effect';
import { orderMileageInquiryFeatureKey, orderMileageInquiryReducer } from '@app/reducers/myoffice/order/order-mileage-inquiry.reducer';
import { OrderMileageInquiryEffect } from '@app/effects/myoffice/order/order-mileage-inquiry.effect';
import { OrderDetailsInquiryComponent } from './order-details-inquiry/order-details-inquiry.component';
import { OrderDetailsInquiryModule } from './order-details-inquiry/order-details-inquiry.module';
import { orderDetailInquiryFeatureKey, orderDetailInquiryReducer } from '@app/reducers/myoffice/order/order-detail-inquiry.reducer';
import { OrderDetailInquiryEffect } from '@app/effects/myoffice/order/order-detail-inquiry.effect';
import { orderPopupFeatureKey, orderPopupReducer } from '@app/reducers/myoffice/order/order-popup.reducer';
import { OrderPopupEffect } from '@app/effects/myoffice/order/order-popup.effect';
import { DirectiveModule } from '@app/directive/directive.module';
import { ComponentsModule } from '@app/components/components.module';
import { RidOrderSearchComponent } from './rid-order-search/rid-order-search.component';
import { RidOrderSearchModule } from './rid-order-search/rid-order-search.module';
import { OrderAnalysisComponent } from './order-analysis/order-analysis.component';
import { memberAnalysisFeatureKey, memAnalysisReducer } from '@reducers/myoffice/member/member-analysis.reducer';
import { MemberAnalysisEffect } from '@effects/myoffice/member/member-analysis.effect';
import { OrderAnalysisEffect } from '@app/effects/myoffice/order/order-analysis.effect';
import { orderAnalysisFeatureKey , orderAnalysisReducer} from '@app/reducers/myoffice/order/order-analysis.reducer';
import { PipeModule } from "../../pipes/pipe.module";
import { OrderSearchNotLoginComponent } from './order-search-not-login/order-search-not-login.component';
import { OrderSearchNotLoginModule } from './order-search-not-login/order-search-not-login.module';
import { orderSearchNotLoginFeatureKey } from '@app/reducers/myoffice/order/order-search-not-login.reducer';
import { orderSearchNotLoginReducer } from '@app/reducers/myoffice/order/order-search-not-login.reducer';
import { OrderSearchNotLoginEffect } from '@app/effects/myoffice/order/order-search-not-login.effect';
@NgModule({
    declarations: [
        OrderSearchComponent,
        SubOrderSearchComponent,
        OrderProductSearchComponent,
        OrderDetailsInquiryComponent,
        OrderCalendarComponent,
        MonthlyOrderCountComponent,
        OrderMileageInquiryComponent,
        RidOrderSearchComponent,
        OrderAnalysisComponent,
        OrderSearchNotLoginComponent,
    ],
    exports: [
        OrderSearchComponent,
        OrderSearchNotLoginComponent
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        OrderSearchModule,
        SubOrderSearchModule,
        OrderProductSearchModule,
        OrderDetailsInquiryModule,
        OrderCalendarModule,
        MonthlyOrderCountModule,
        OrderMileageInquiryModule,
        RidOrderSearchModule,
        OrderRoutingModule,
        DirectiveModule,
        GoogleChartsModule,
        OrderSearchNotLoginModule,
        StoreModule.forFeature(orderSearchFeatureKey, orderSearchReducer),
        StoreModule.forFeature(orderProductSearchFeatureKey, orderProductSearchReducer),
        StoreModule.forFeature(orderCalendarFeatureKey, orderCalendarReducer),
        StoreModule.forFeature(monthlyOrderCountFeatureKey, monthlyOrderCountReducer),
        StoreModule.forFeature(orderMileageInquiryFeatureKey, orderMileageInquiryReducer),
        StoreModule.forFeature(orderDetailInquiryFeatureKey, orderDetailInquiryReducer),
        StoreModule.forFeature(orderPopupFeatureKey, orderPopupReducer),
        StoreModule.forFeature(memberAnalysisFeatureKey, memAnalysisReducer),
        StoreModule.forFeature(orderAnalysisFeatureKey, orderAnalysisReducer),
        StoreModule.forFeature(orderSearchNotLoginFeatureKey, orderSearchNotLoginReducer),
        EffectsModule.forFeature([
            OrderSearchEffect,
            OrderProductSearchEffect,
            OrderCalendarEffect,
            MonthlyOrderCountEffect,
            OrderMileageInquiryEffect,
            OrderDetailInquiryEffect,
            OrderPopupEffect,
            MemberAnalysisEffect,
            OrderAnalysisEffect,
            OrderSearchNotLoginEffect,
        ]),
        PipeModule
    ]
})
export class OrderModule { }
